import { onMounted, onUnmounted } from 'vue';
import 'aos/dist/aos.css';
import AOS from 'aos';

export const useAOS = () => {
  onMounted(() => {
    AOS.init();
  });

  onUnmounted(() => {
    AOS.refresh();
  });
};
